var _circle, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIst(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 8C9.5 6.61929 10.6193 5.5 12 5.5C13.3807 5.5 14.5 6.61929 14.5 8C14.5 9.38071 13.3807 10.5 12 10.5C11.6354 10.5 11.2891 10.422 10.9767 10.2817C10.6733 10.4629 10.4219 10.7223 10.2503 11.0319C10.765 11.3296 11.3626 11.5 12 11.5C13.933 11.5 15.5 9.933 15.5 8C15.5 6.067 13.933 4.5 12 4.5C10.067 4.5 8.5 6.067 8.5 8C8.5 8.54959 8.62667 9.06959 8.85241 9.5324C9.07488 9.24895 9.33479 8.99629 9.6247 8.78187C9.54378 8.53589 9.5 8.27306 9.5 8Z",
    fill: "url(#paint0_linear_3426_34091)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8.5C10.067 8.5 8.5 10.067 8.5 12V16C8.5 17.933 10.067 19.5 12 19.5C13.933 19.5 15.5 17.933 15.5 16V12C15.5 11.4507 15.3735 10.931 15.148 10.4684C14.9254 10.7517 14.6654 11.0043 14.3755 11.2187C14.4563 11.4645 14.5 11.7271 14.5 12V16C14.5 17.3807 13.3807 18.5 12 18.5C10.6193 18.5 9.5 17.3807 9.5 16V12C9.5 10.6193 10.6193 9.5 12 9.5C12.3648 9.5 12.7113 9.57813 13.0238 9.71856C13.3273 9.5374 13.5787 9.27812 13.7504 8.96849C13.2355 8.67054 12.6377 8.5 12 8.5Z",
    fill: "url(#paint1_linear_3426_34091)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3426_34091",
    x1: 15.5,
    y1: 4.5,
    x2: 8.5,
    y2: 11.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.10619,
    stopColor: "#4F39DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.928551,
    stopColor: "#C37DE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3426_34091",
    x1: 15.5,
    y1: 8.5,
    x2: 8.5,
    y2: 19.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.163649,
    stopColor: "#B172E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.646985,
    stopColor: "#F6614A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8B740"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIst);
export default __webpack_public_path__ + "static/media/ist.006d59309e2288fc560fac5adbc422ef.svg";
export { ForwardRef as ReactComponent };